import PropTypes from "prop-types";
import { connect } from "react-redux";

import {
  ELITE_ACCOUNTS,
  PLATINUM_ACCOUNTS,
} from "../../../../constants/strings";
import { QUEUE_TYPES } from "../../../../features/customerSettings/customerSettings.constants";
import {
  getChatQueueAccountFilter,
  getChatQueueListRevision,
} from "../../../../features/customerSettings/customerSettings.selectors";
import ChatQueueAccountsTable from "../ChatQueueAccountsTable";

const ChatQueueAccountsList = ({ account = "", listRevision }) => (
  <>
    <ChatQueueAccountsTable
      key={`${QUEUE_TYPES.ELITE}-${account}-${listRevision}`}
      title={ELITE_ACCOUNTS}
      queueType={QUEUE_TYPES.ELITE}
      account={account}
    />
    <ChatQueueAccountsTable
      key={`${QUEUE_TYPES.PLATINUM}-${account}-${listRevision}`}
      title={PLATINUM_ACCOUNTS}
      queueType={QUEUE_TYPES.PLATINUM}
      account={account}
    />
  </>
);

ChatQueueAccountsList.propTypes = {
  account: PropTypes.string,
  listRevision: PropTypes.number,
};

const mapStateToProps = (state) => ({
  account: getChatQueueAccountFilter(state),
  listRevision: getChatQueueListRevision(state),
});

export default connect(mapStateToProps)(ChatQueueAccountsList);
